import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { toggleSwitch, popUpMenuChange } from '../../actions/index';
import ExportButton from '../menu/exportButton';

class ExportObservationsButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            buttonDisabled: false,
        };
    }

    handleButtonStateChange = (isDisabled) => {
        this.setState({ buttonDisabled: isDisabled });
    };

    render() {

        const className = this.state.buttonDisabled ? "disabled-popup-menu-export-button" : "popup-menu-export-button";

        return (
            <div>
                { !this.props.popUpMenu.close &&
                    <div className={`${className} card-color`} ref={ref => (this.button = ref)}>
                        <ExportButton 
                            popUpMenu={true} 
                            name={'Observaciones'} 
                            endpoint={'export-observations'} 
                            postData={'postDataBlob'} 
                            onStateChange={this.handleButtonStateChange}
                            ext={'.xlsx'}
                        />
                    </div>
                }
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        popUpMenu: state.popUpMenu,
    };
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            toggleSwitch,
            popUpMenuChange,
        },
        dispatch
    );
}

export default connect(mapStateToProps, matchDispatchToProps)(ExportObservationsButton);
